import {Component, inject, input, OnInit} from '@angular/core';
import {BreadcrumbService} from '@core/services/breadcrumb.service';
import {NgOptimizedImage} from '@angular/common';
import {toSignal} from '@angular/core/rxjs-interop';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-search-page-title',
  templateUrl: './search-page-title.component.html',
  styleUrls: ['./search-page-title.component.scss'],
  imports: [
    NgOptimizedImage
  ]
})
export class SearchPageTitleComponent implements OnInit {
  private breadcrumbService = inject(BreadcrumbService);

  protected hasBreadcrumbs = toSignal(
    this.breadcrumbService.getCurrentBreadcrumbsAsync().pipe(
      map(breadcrumbs => breadcrumbs?.length > 0)
    ),
    {initialValue: false}
  );

  default_background_image = '/assets/images/top_image.webp';

  readonly title = input<string>();
  readonly description = input<string>();
  readonly icon = input<any>();
  readonly background_image = input<any>();
  readonly subtitle = input<string>();
  readonly general_styling = input<any>();

  ngOnInit(): void {
    if (this.title() && this.breadcrumbService.isAutoChangeEnabled) {
      this.breadcrumbService.updateStyle('light');
    }
  }

  scrollToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
